import { root } from "@shared/utils";
import cn from "classnames";
import React, { memo } from "react";
import Modal from "react-modal";
import { useDispatch } from "react-redux";

import { toggleResponseInternetTimeModal } from "../../actions/actions";
import { useIsSweepstakesEnabled } from "../../hooks/use-is-sweepstakes-enabled";
import { useModalBuyInternetResponseTimeModal } from "../../selectors/selectors";

import { Button } from "./Button";
import s from "./style.module.css";

export const BuyInternetTimeResponseModal: React.FC = memo(() => {
  const dispatch = useDispatch();
  const isSweepstakesEnabled = useIsSweepstakesEnabled();
  const { isShow: isResponseInternetTimeModalShown, isError } =
    useModalBuyInternetResponseTimeModal();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ModalComponent = Modal as any;

  if (!isSweepstakesEnabled) {
    return null;
  }

  return (
    <ModalComponent
      isOpen={isResponseInternetTimeModalShown}
      contentLabel="BuyInternetTime Modal"
      overlayClassName={s.buyInternetTimeOverlay}
      className={s.buyInternetTimeContent}
      appElement={root as HTMLElement}
      onRequestClose={() => dispatch(toggleResponseInternetTimeModal(false))}
    >
      <div className={cn("modal-title", s.responseModalContentTitle)}>
        {isError ? "Error" : "Success"}
      </div>
      <span className={s.responseModalText}>
        {isError ? "Try Again" : "Time successfully bought"}
      </span>
      <div className={s.responseModalButtons}>
        <Button
          title="close"
          value={0}
          disabled={false}
          handleClick={() => dispatch(toggleResponseInternetTimeModal(false))}
        />
      </div>
    </ModalComponent>
  );
});

BuyInternetTimeResponseModal.displayName = "BuyInternetTimeResponseModal";
